import { PathGroup } from '../api/path-group';

export const Paths: PathGroup = {
    base: '/es-ES/',
    contact: 'contacto',
    fees: 'honorarios',
    rodo: 'proteccion-de-datos',
    notarialActivities: {
        base: 'actividades-notariales',
        inheritanceLaw: 'derecho-de-sucesiones',
        familyLaw: 'derecho-de-familia',
        realEstate: 'derecho-inmobiliario',
        certificates: 'asuntos-empresariales-y-otras-actividades',
    }
}
